<app-loader [loading]="isLoading"></app-loader>
<ng-container *ngIf="bill">
  <form [formGroup]="form" *ngIf="form">
    <div class="mb-4">
      <label for="taxCategory">{{ "e-invoice.type" | translate }}</label>
      <ng-select [items]="options" [searchable]="false" [clearable]="false" formControlName="type" [disabled]="true" [tabFocusOnClearButton]="false"></ng-select>
    </div>
    <div>
      <div class="relative mb-4" [ngClass]="form.controls['taxCategory'].touched ? (form.controls['taxCategory'].errors ? 'has-error' : 'has-success') : ''">
        <label for="taxCategory">{{ "tax_categories.category" | translate }}</label>
        <ng-select
          placeholder="{{ 'tax_categories.enter_category' | translate }}"
          labelForId="taxCategory"
          [items]="taxCategoryOptions$ | async"
          bindLabel="title"
          formControlName="taxCategory"
          [searchable]="false"
          [clearable]="false"
          class="custom-multiselect"
          appendTo="body"
          [tabFocusOnClearButton]="false"
        >
        </ng-select>
        <ng-container *ngIf="form.controls['taxCategory'].touched && form.controls['taxCategory'].errors">
          <p class="mt-1 text-danger">
            <small>{{ "tax_categories.please_provide_category" | translate }}</small>
          </p>
        </ng-container>
      </div>
    </div>
    <div class="mb-4">
      <label for="taxRate">{{ "e-invoice.tax_rate" | translate }}</label>
      <div class="flex">
        <input type="text" class="form-input flex-1 ltr:rounded-l-md ltr:rounded-r-none rtl:rounded-r-none rtl:border-l-0" labelForId="taxRate" readonly [value]="taxRate" />
        <div
          class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0"
        >
          %
        </div>
      </div>
    </div>
    <div class="mb-4">
      <label for="planSum">{{ "e-invoice.sum" | translate }} {{ bill.currencyCode }}</label>
      <div class="flex">
        <input
          type="text"
          placeholder="{{ 'e-invoice.sum_in_rsd' | translate }}"
          mask="separator.2"
          [outputTransformFn]="formatValue"
          class="form-input flex-1 ltr:rounded-l-md ltr:rounded-r-none rtl:rounded-r-none rtl:border-l-0 rtl:pr-10"
          id="planSum"
          formControlName="initialAmount"
        />
        <div
          class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0"
        >
          {{ exchangeService.getCurrencySymbol(bill.currencyCode) }}
        </div>
      </div>
    </div>

    <div
      class="flex cursor-pointer items-center space-x-1 rounded-md border border-green-500 bg-white px-3 py-1.5 text-sm font-medium text-green-600 shadow-sm transition hover:bg-green-50 mb-4"
      (click)="showTaxForm = !showTaxForm"
    >
      <ng-container *ngIf="!showTaxForm; else closeIcon">
        <icon-plus class="text-sm"></icon-plus>
      </ng-container>
      <ng-template #closeIcon>
        <icon-x class="text-sm"></icon-x>
      </ng-template>

      <span class="whitespace-nowrap">
        {{ "calculation_options" | translate }}
      </span>
    </div>

    <ng-container *ngIf="showTaxForm">
      <div class="mb-4">
        <label for="category">{{ "e-invoice.category" | translate }}</label>
        <ng-select [items]="categories" [searchable]="true" [clearable]="true" (change)="setReasonsByCategory($event)" formControlName="taxLabel" [tabFocusOnClearButton]="false"> </ng-select>
      </div>

      <ng-container *ngIf="!isSCategory">
        <div class="mb-4">
          <label for="key">{{ "e-invoice.key" | translate }}</label>
          <ng-select [items]="filteredReasons" bindLabel="key" bindValue="key" [searchable]="true" [clearable]="true" formControlName="taxExemptionReasonCode" [tabFocusOnClearButton]="false"> </ng-select>
        </div>

        <div class="mb-4">
          <label for="taxExemptionReason">{{ "e-invoice.taxExemptionDecisionNumber" | translate }}</label>
          <input type="text" id="taxExemptionReason" class="form-input flex-1" placeholder="{{ 'e-invoice.enterDecisionNumber' | translate }}" formControlName="taxExemptionReason" />
        </div>
      </ng-container>
      <div class="mb-4" *ngIf="isSCategory">
        <label for="descriptionCode">{{ "e-invoice.description_code" | translate }}</label>
        <ng-select [items]="descriptionCodeOptions" bindLabel="label" bindValue="value" [clearable]="true" [searchable]="false" formControlName="descriptionCode" [tabFocusOnClearButton]="false"> </ng-select>
      </div>
    </ng-container>

    <div class="relative mb-4" [ngClass]="form.controls['amount'].touched ? (form.controls['amount'].errors ? 'has-error' : 'has-success') : ''">
      <label for="sumInRSD">{{ "e-invoice.sum" | translate }} RSD:</label>
      <div class="flex">
        <input
          type="text"
          placeholder="{{ 'e-invoice.sum_in_rsd' | translate }}"
          mask="separator.2"
          [outputTransformFn]="formatValue"
          class="form-input flex-1 ltr:rounded-l-md ltr:rounded-r-none rtl:rounded-r-none rtl:border-l-0 rtl:pr-10"
          id="sumInRSD"
          formControlName="amount"
        />
        <div
          class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0"
        >
          Din
        </div>
      </div>
      <ng-container *ngIf="form.controls['amount'].touched && form.controls['amount'].errors">
        <small class="mt-1 text-danger">{{ "e-invoice.please_provide_sum_in_rsd" | translate }}</small>
      </ng-container>
    </div>
    <div class="mb-4">
      <label for="contractNumber">{{ "e-invoice.contract_number" | translate }}</label>
      <input type="text" id="contractNumber" class="form-input" placeholder="{{ 'e-invoice.enter_contract_number' | translate }}" formControlName="contractNumber" />
    </div>

    <div class="mb-4" [ngClass]="form.controls['actualDeliveryDate'].touched ? (form.controls['actualDeliveryDate'].errors ? 'has-error' : 'has-success') : ''">
      <label for="actualDeliveryDate">{{ "e-invoice.actualDeliveryDate" | translate }}</label>
      <input id="actualDeliveryDate" type="text" class="form-input" formControlName="actualDeliveryDate" class="form-input" placeholder="__.__.____" mask="d0.M0.0000" [showMaskTyped]="true" />
      <ng-container *ngIf="form.controls['actualDeliveryDate'].touched">
        <ng-container *ngIf="form.controls['actualDeliveryDate'].errors">
          <p class="mt-1 text-danger">{{ "e-invoice.please_provide_actualDeliveryDate" | translate }}</p>
        </ng-container>
      </ng-container>
    </div>

    <div class="mb-4" [ngClass]="form.controls['dueDate'].touched ? (form.controls['dueDate'].errors ? 'has-error' : 'has-success') : ''">
      <label for="dueDate">{{ "e-invoice.dueDate" | translate }}</label>
      <input id="dueDate" type="text" class="form-input" formControlName="dueDate" class="form-input" placeholder="__.__.____" mask="d0.M0.0000" [showMaskTyped]="true" />
      <ng-container *ngIf="form.controls['dueDate'].touched">
        <ng-container *ngIf="form.controls['dueDate'].errors">
          <p class="mt-1 text-danger">{{ "e-invoice.please_provide_dueDate" | translate }}</p>
        </ng-container>
      </ng-container>
    </div>

    <label>{{ "e-invoice.sendToCir" | translate }}:</label>
    <div class="flex items-center space-x-4">
      <label for="yesOption" class="flex items-center">
        <input type="radio" id="yesOption" name="sendToCirOption" formControlName="sendToCirOption" [value]="SendToCirOption.Yes" class="mr-2 form-radio" />
        {{ "e-invoice.yes" | translate }}
      </label>
      <label for="noOption" class="flex items-center">
        <input type="radio" id="noOption" name="sendToCirOption" formControlName="sendToCirOption" [value]="SendToCirOption.No" class="mr-2 form-radio" />
        {{ "e-invoice.no" | translate }}
      </label>
    </div>

    <div class="mt-4 flex items-center justify-center">
      <button type="button" class="btn btn-primary" (click)="checkCompanyBeforeSending()" [disabled]="isLoading">
        {{ "e-invoice.sendToEInvoiceButton" | translate }}
      </button>
    </div>
  </form>
</ng-container>
